<mat-card class="recomendation-card"
          [ngStyle]="{ 'width.px': width, 'height.px': height }"
          (click)="handleClick($event)">
  <img mat-card-image class="recomendation-card__image" [src]="imageSrc" alt='Drink' />
  <div class="card-info">
    <div class="card-info__title">{{ drink | fieldTranslate: 'title' }}</div>

    <!-- Price food -->
    <div class="card-info-price" *ngIf="drink.price as value">
      <ng-container *ngIf="value | priceSeparator as separated">
        <span *ngIf="drink.variability" class="card-info-price__from">{{ 'from' | translate }} </span>
        <span class="card-info-price__whole">{{ separated.whole }}</span>
        <span class="card-info-price__dot">{{ separated.separator }}</span>
        <span class="card-info-price__fraction">{{ separated.fraction }}</span>
        <span class="card-info-price__currency">{{ locale?.currency }}</span>
      </ng-container>
    </div>
  </div>

  <!-- Basket -->
  <div class="card-info-basket" *ngIf="getBasketDrink() as basketItem">
    <img src="assets/basket.svg" alt="basket" class="card-info-basket__icon" />
    <span class="card-info-basket__count">{{ basketItem.count }}</span>
  </div>
</mat-card>